import { AddressValidatorModule } from './../shared/address-validator/address-validator.module';
import { DirectorySearchModule } from './../shared/directory-search/directory-search.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { TeamListComponent } from './team-list/team-list.component';
import { TeamAssignComponent } from './team-assign/team-assign.component';
import { TeamEditComponent } from './team-edit/team-edit.component';
import { TeamEditNonUserComponent } from './team-edit-non-user/team-edit-non-user.component';
import { ProviderListService } from '../core/service/grid-data/grid-data-provider.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TeamRoleListComponent } from './team-role/team-role-list/team-role-list.component';
import { TeamRoleEditComponent } from './team-role/team-role-edit/team-role-edit.component';
import { EventModule } from '../event/event.module';

@NgModule({
  declarations: [
    TeamListComponent,
    TeamAssignComponent,
    TeamEditComponent,
    TeamEditNonUserComponent,
    TeamRoleListComponent,
    TeamRoleEditComponent
  ],
  imports: [
    SharedModule,
    NgbModule,
    DirectorySearchModule,
    EventModule,
    AddressValidatorModule
  ],
  exports: [
    TeamListComponent
  ],
  providers: [ProviderListService]
})
export class TeamModule { }
